






















import { Vue, Component, Prop, p } from "av-ts";

import Rating from "./Rating.vue";

@Component({
    components: {
        Rating
    }
})
export default class QuestionRater extends Vue {
    @Prop icon = p({
        type: String,
        default: "star"
    });
    @Prop disabled = p({
        type: Boolean,
        default: false
    });
    @Prop defaultValue = p({
        type: Number,
        default: 0
    });
    @Prop rateAction = p({
        type: Function
    });
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionRater.vue